import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { findNavItemForPathname } from '../constants/navigationItems';
import { recordNavClick } from '../utils/navUsage';

/**
 * Records navigation usage when the route changes (including direct URL loads).
 */
export function NavUsageTracker({ items }) {
  const location = useLocation();
  const lastRecordedId = useRef(null);

  useEffect(() => {
    const match = findNavItemForPathname(location.pathname, items);
    if (!match?.id || match.id === lastRecordedId.current) return;
    lastRecordedId.current = match.id;
    recordNavClick(match.id);
  }, [location.pathname, items]);

  return null;
}
